const REQUIRED_VARS = [
  'VITE_SUPABASE_URL',
  'VITE_SUPABASE_ANON_KEY',
  // VITE_GEMINI_API_KEY intentionally excluded:
  //   Production → key lives in server-only GEMINI_API_KEY (Vercel env), never in bundle
  //   Development → set in .env.local; gemini.ts warns if missing
  'VITE_STRIPE_PUBLISHABLE_KEY',
  'VITE_STRIPE_MONTHLY_PRICE_ID',
  'VITE_STRIPE_ANNUAL_PRICE_ID',
  'VITE_SENTRY_DSN',
  'VITE_POSTHOG_KEY',
  'VITE_APP_URL',
  // VITE_SENTRY_RELEASE intentionally excluded — CI-injected only
  //
  // Server-side only vars (NOT validated here — these are Vercel env vars, not VITE_):
  //   SENTRY_DSN                         — server-side Sentry for api/generate-ai.ts
  //                                        Set to the same DSN value as VITE_SENTRY_DSN.
  //                                        Optional: absent = no-op (Sentry init guarded by existence check).
  //   GOOGLE_APPLICATION_CREDENTIALS_JSON — Vertex AI service account JSON
  //   GOOGLE_CLOUD_PROJECT               — GCP project ID for Vertex AI
  //   ANTHROPIC_API_KEY                  — Claude Haiku server-side fallback
  //   SUPABASE_SERVICE_ROLE_KEY          — rate limiter + subscription gate
] as const

export function validateEnv(): void {
  const missing = REQUIRED_VARS.filter(
    (key) => !import.meta.env[key]
  )
  if (missing.length > 0) {
    throw new Error(
      `[Nudge] Missing required environment variables:\n` +
      `${missing.map((k) => `  - ${k}`).join('\n')}\n` +
      `Check your .env.local file against env-secrets.md`
    )
  }
}
